import React from 'react';
import AccessDeniedImg from 'assets/accessManagement/securityBg.svg';
import s from './s.module.less';

type Props = {
    statesAndFeeMap?: { states: string[], fee: number }[]
};

const LeadGenFeeTable = (props: Props) => {
    const { statesAndFeeMap } = props;
    return (
        <div className={s.feeTable}>
            <div className={s.th}>
                <div className={s.tdFee}>
                    LEAD-gen FEE PER BOOKING
                </div>
                <div className={s.tdState}>
                    States
                </div>
            </div>
            {
                statesAndFeeMap?.map((item) => {
                    return (
                        <div className={s.tr} key={item.fee}>
                            <div className={s.tdFee}>
                                ${item.fee}
                            </div>
                            <div className={s.tdState}>
                                {item.states.join(', ')}
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default LeadGenFeeTable;
